import { setClientForDestination } from "@/App/utils/whitelabel";
import { FC, useMemo } from "react";
import { Navigate, NavigateProps, useSearchParams } from "react-router";

type ClientAwareNavigateProps = NavigateProps;

export const ClientAwareNavigate: FC<ClientAwareNavigateProps> = (props) => {
  const [searchParams] = useSearchParams();

  const clientAwareDestination = useMemo(() => {
    const client = searchParams.get("client");
    return setClientForDestination(client, props.to);
  }, [props.to, searchParams]);

  const clientAwareLinkProps = useMemo((): NavigateProps => {
    const interpolatedProps = {
      ...props,
      to: clientAwareDestination,
    };

    return interpolatedProps;
  }, [clientAwareDestination, props]);

  return <Navigate {...clientAwareLinkProps} />;
};
